import React, { useMemo, useState } from 'react';
import * as THREE from "three";

import { const_var, params } from '../../../../redux/reducers/reducer';
import { extrudeSettings, railModel } from '../../../../utils/Functions';
import { wallNameArrForValid } from '../../../../utils/Validation';
import { CSG } from '../../../../assets/libs/csg-lib';

import VerticalLegs from './VerticalLegs';
import { MaterialTruss } from '../../CustomMaterial';

const PillarRailModel = ({ trussType, trussModelPosInfoArr, normalMap, envMap, meshDelModel_CSG, overlapTrussArr, hiddenBaseRailIdArr, roofRailDistanceY=0, hangRailDivision=1 }) => {

    const obj_leftOuterPillar = new THREE.Object3D();
    const obj_leftInnerPillar = new THREE.Object3D();
    const obj_leftConnectRail = new THREE.Object3D();
    const obj_leftConnectBottomRail = new THREE.Object3D();
    
    const obj_rightOuterPillar = new THREE.Object3D();
    const obj_rightInnerPillar = new THREE.Object3D();
    const obj_rightConnectRail = new THREE.Object3D();
    const obj_rightConnectBottomRail = new THREE.Object3D();
    
    const obj_leftStoragePillar = new THREE.Object3D();
    const obj_rightStoragePillar = new THREE.Object3D();

    const [leftOuterPillar, setLeftOuterPillar] = useState(new THREE.InstancedBufferAttribute(new Float32Array([]), 16));
    const [leftInnerPillar, setLeftInnerPillar] =  useState(new THREE.InstancedBufferAttribute(new Float32Array([]), 16));   
    const [leftConnectBottomRail, setLeftConnectBottomRail] =  useState(new THREE.InstancedBufferAttribute(new Float32Array([]), 16));
    const [rightOuterPillar, setRightOuterPillar] = useState(new THREE.InstancedBufferAttribute(new Float32Array([]), 16));
    const [rightInnerPillar, setRightInnerPillar] = useState(new THREE.InstancedBufferAttribute(new Float32Array([]), 16)); 
    const [rightConnectBottomRail, setRightConnectBottomRail] =  useState(new THREE.InstancedBufferAttribute(new Float32Array([]), 16));

    const [leftStoragePillar, setLeftStoragePillar] = useState(new THREE.InstancedBufferAttribute(new Float32Array([]), 16));
    const [rightStoragePillar, setRightStoragePillar] = useState(new THREE.InstancedBufferAttribute(new Float32Array([]), 16));
    
    const [csgLeftLegIdArr, setCsgLeftLegIdArr] = useState([])
    const [csgRightLegIdArr, setCsgRightLegIdArr] = useState([])
    const [csgLeftStorageLegIdArr, setCsgLeftStorageLegIdArr] = useState([])
    const [csgRightStorageLegIdArr, setCsgRightStorageLegIdArr] = useState([])

    const railWidth = 0.2;
    const railHeight = 0.3;
    const isEven = (i) => (i % 2 === 0)

    const sideBracingType = const_var.selected_scbracing // side braing
    const endBracingType = const_var.selected_ecbracing // end braing
    const endBracingDivider = (endBracingType == "invert_v_bracings" || endBracingType == "v_bracings") ? 4 : 2;
    const endBracingHeightVal = (endBracingType == "k_bay_bracings") ? -0.5 : 0;
    const sideBracingHeightVal = (sideBracingType == "k_bay_bracings") ? -0.5 : 0;
    
    const roofRegularOffsetHeight = useMemo(() => {
        let val = 0;
        if (params.p_r_s === 1) val = const_var.roofRegularDst * 2;
        else val = 0;

        return val;
    }, [params.p_r_s])
    
    const outInDistance = useMemo(() => {
        return  (const_var.legstype === "double") ? 0.21 : 
                (const_var.legstype === "ladder") ? 0.5 : 
                (const_var.legstype === "zigzag") ? 1 : 0;
    }, [const_var.legstype])

    const legDistance_temp = useMemo(() => {
        return (const_var.DistanceArr.length>0 && const_var.DistanceArr[params.p_b_t][params.p_r_s]!=undefined) ? const_var.DistanceArr[params.p_b_t][params.p_r_s] : 5
    }, [const_var.DistanceArr, params.p_b_t, params.p_r_s,params.fourth_center_cost])

    const legDistance = useMemo(() => {
        let distance = 0;
        if (trussModelPosInfoArr.length > 1) distance = trussModelPosInfoArr[1] - trussModelPosInfoArr[0];

        return distance;
    }, [trussModelPosInfoArr,legDistance_temp])




    const roofCutModelForBraceGeo = useMemo(() => {
        const thikness = 4
        const sideOverHang = params.p_w
        const width = params.p_w
        const regularHeight = (params.p_r_s == 1) ? roofRegularOffsetHeight - 0.3 : 0

        const model = new THREE.Shape();
        model.moveTo(-((width / 2) + sideOverHang), params.p_h + regularHeight - ((params.p_r_p/12) * (sideOverHang)));
        model.lineTo(0, params.p_h + regularHeight + ((params.p_r_p/12) * (width / 2)));
        model.lineTo(((width / 2) + sideOverHang), params.p_h + regularHeight  - ((params.p_r_p/12) * (sideOverHang)));
        model.lineTo(((width / 2) + sideOverHang), params.p_h + regularHeight  - ((params.p_r_p/12) * (sideOverHang)) + thikness);
        model.lineTo(0, params.p_h + regularHeight + ((params.p_r_p/12) * (width / 2)) + thikness);
        model.lineTo(-((width / 2) + sideOverHang), params.p_h + regularHeight  - ((params.p_r_p/12) * (sideOverHang)) + thikness);

        return model;
    }, [params.p_w, params.p_h, params.p_r_p,roofRegularOffsetHeight, params.p_r_s])

    const baseThickness = params.p_h
    const baseCutModelForBraceGeo = railModel(params.p_w+4, baseThickness);
    const baseCutModelForBraceMesh = new THREE.Mesh(
        new THREE.ExtrudeGeometry(baseCutModelForBraceGeo, extrudeSettings(params.p_d+4),
        new THREE.MeshStandardMaterial({ color: 'pink' })
        )
    )
    const roofCutMdelForBraceMesh = new THREE.Mesh(
        new THREE.ExtrudeGeometry(roofCutModelForBraceGeo, extrudeSettings(params.p_d),
        new THREE.MeshStandardMaterial({ color: 'pink' })
        )
    )
    const connectRailDataArr = useMemo(() => {
        let dataInfoArray = [];
        let count, distance;

        let initDistance = (const_var.legstype === 'zigzag') ? 1 : 2;
        const tempCount = Math.floor(params.p_h / initDistance);
        if (params.p_h === tempCount * initDistance) {
            count = tempCount;
            distance = initDistance;
        } else if (params.p_h - tempCount * initDistance <= initDistance / 2) {
            count = tempCount;
            distance = params.p_h / count;
        } else {
            count = tempCount + 1;
            distance = params.p_h / count;
        }

        for (let i = 0; i < count; i++) {            
            const length = ((i === 0) ? outInDistance : (outInDistance / Math.cos(Math.PI / 4)))
            const pos_x_R = params.p_w / 2 - railWidth / 2 - (const_var.legstype === 'zigzag' ? (isEven(i) ? outInDistance : 0) : 0);
            const pos_y = distance * i + railWidth / 2;
            const rotationX = Math.atan((distance) / outInDistance)

            const tempInfoObj = {
                pos_x_R: pos_x_R,
                distance,
                pos_y: pos_y,
                length: const_var.legstype === 'zigzag' ? length : outInDistance,
                rotationX: const_var.legstype === 'zigzag' ? isEven(i) ? (i === 0 ? Math.PI : (Math.PI / 2 + rotationX)) : rotationX : 0
            }

            dataInfoArray.push(tempInfoObj);
        }
        const lengthZigzag = outInDistance / Math.cos(Math.PI / 4);
        const lengthLadder = outInDistance;

        return {
            lengthZigzag,
            lengthLadder,

            dataInfoArray
        }
    }, [params.p_h, params.p_w, const_var.legstype])
    
    const frontBackPillarRailDataArr = useMemo(() => {
        let dataInfoArray = []
        let endCrossBracingLegs = []
        let endCrossBracingHorizonTruss = []
        let endCrossBracingSlopeTruss = []
        let count, distance = 0;
        let horizonTrussCount = 0
        
        const initDistance = legDistance;
        const tempCount = Math.floor(params.p_w / initDistance);
        if (params.p_w === tempCount * initDistance) {
            count = tempCount;
            distance = initDistance;
        } else if (params.p_w - tempCount * initDistance <= initDistance / 2) {
            count = tempCount;
            distance = params.p_w / count;
        } else {
            count = tempCount + 1;
            distance = params.p_w / count;
        }
        
        const endRailHeightForBracing = (endBracingType == "invert_v_bracings" || endBracingType == "v_bracings") ? 0 : railHeight
        const horizonTrussDistance = (distance / 2) / 4 * 5;
        const tempHorizonTrussCount = Math.floor(params.p_h / horizonTrussDistance)
        const endSlopeTrussAngle = Math.atan((distance / endBracingDivider) / (horizonTrussDistance + railHeight))
        const endSlopeTrussLength = Math.sqrt(Math.pow(horizonTrussDistance, 2) + Math.pow((distance / endBracingDivider - endRailHeightForBracing), 2))

        if (params.p_h > horizonTrussDistance * tempHorizonTrussCount) {
            horizonTrussCount = tempHorizonTrussCount + 1;
        } else {
            horizonTrussCount = tempHorizonTrussCount;
        }
        
        for (let i = 1; i < count; i++) {
            const pos_x = distance * i - params.p_w / 2;
            let shortLength = 0;
            let longLength = 0;
            let length = 0;
            let asyncLength = 0;
            const isLeftFreeStanding = params.singleSlope && params.freeStandingSide === "left";
            const isRightFreeStanding = params.singleSlope && params.freeStandingSide === "right";

            const defaultLength = params.p_h + (params.p_w / 2 - Math.abs(pos_x)) * (params.p_r_p / 12);
            if (trussType === "" || trussType === "standard") {
                shortLength = defaultLength;
                longLength = defaultLength;
            } else {
           
                if (params.trussType === "HSST"){
                    shortLength = defaultLength - roofRailDistanceY; 
                    longLength =  params.p_h + (params.p_w / 2.8 ) * (params.p_r_p / 12) - roofRailDistanceY;
                }else{
                    shortLength = defaultLength - roofRailDistanceY;
                    longLength =  params.p_h + params.p_w / 2 * (1 - hangRailDivision) * params.p_r_p / 12 - roofRailDistanceY;
                }
            }
            
            if (params.p_w > 24 || params.trussType === "HSST") {
                if (!isLeftFreeStanding) {
              
                    if (params.trussType === "HSST"){
                        length = Math.abs(pos_x) > params.p_w / 4 * hangRailDivision ? shortLength : longLength;
                    }else{
                        length = Math.abs(pos_x) > params.p_w / 2 * hangRailDivision ? shortLength : longLength;
                    }
                } else {
                    length = params.p_h - (params.p_w * (params.p_r_p / 12)) + (distance * i) * (params.p_r_p / 12);
                }
            } else if (isLeftFreeStanding) {
                length = params.p_h - (params.p_w * (params.p_r_p / 12)) + (distance * i) * (params.p_r_p / 12);
            } else if (isRightFreeStanding) {
                length = params.p_h + (distance * i) * (params.p_r_p / 12);
            } else {
                length = params.p_h + (params.p_w / 2 - Math.abs(pos_x)) * (params.p_r_p / 12);
            }
            if (isLeftFreeStanding) {
                asyncLength = params.p_h - (params.p_w * (params.p_r_p / 12)) + (distance * i) * (params.p_r_p / 12);
            } else if (isRightFreeStanding) {
                asyncLength = params.p_h + (distance * i) * (params.p_r_p / 12);
            } else {
                asyncLength = params.p_h + (params.p_w / 2 - Math.abs(pos_x)) * (params.p_r_p / 12);
            }
            
            const tempInfoObj ={
                pos_x: pos_x,
                length: length - railWidth / 2 + roofRegularOffsetHeight,
                asyncLength: asyncLength - railWidth / 2 + roofRegularOffsetHeight,
            }
            
            dataInfoArray.push(tempInfoObj);
        }
    
      

        for(let i = 0; i < 2; i++) {
            let pos_x;
            
            const length = params.p_h + (distance / 2) * (params.p_r_p / 12);
            if(i === 0) {
                pos_x = -params.p_w / 2 + distance / 2
                for(let j = 0; j < horizonTrussCount; j++) {
                    let pos_y;
                    pos_y = horizonTrussDistance * j
                    const tempHorizonTrussInfoObj = {
                        pos_x: pos_x,
                        pos_y: pos_y + railWidth / 2,
                        length: distance / 2 - railWidth / 2
                    }
                    endCrossBracingHorizonTruss.push(tempHorizonTrussInfoObj)
                }
                for(let k = endBracingHeightVal; k < horizonTrussCount - 1; k++) {
                    let pos_y;
                    pos_y = horizonTrussDistance * k
                    const tempSlopeTrussInfoObj = {
                        pos_x: pos_x,
                        pos_y: pos_y,
                        length: endSlopeTrussLength,
                        rotationZ : endSlopeTrussAngle
                    }
                    endCrossBracingSlopeTruss.push(tempSlopeTrussInfoObj)
                }
            } else if (i === 1) {
                let pos_y;
                let horizonCount;
                pos_x = params.p_w / 2 - distance / 2
                
                if(params.singleSlope && (horizonTrussDistance * (horizonTrussCount - 1)) > (params.p_h - (distance + railWidth / 2) * params.p_r_p / 12)){
                    horizonCount = horizonTrussCount - 1;
                } else {
                    horizonCount = horizonTrussCount;
                }

                for(let j = 0; j < horizonCount; j++) {
                    pos_y = horizonTrussDistance * j
                    const tempHorizonTrussInfoObj = {
                        pos_x: pos_x + distance / 2 - railWidth / 2,
                        pos_y: pos_y + railWidth / 2,
                        length: distance / 2 - railWidth / 2
                    }
                    endCrossBracingHorizonTruss.push(tempHorizonTrussInfoObj)
                    
                }
                for(let k = endBracingHeightVal; k < horizonTrussCount - 1; k++) {
                    pos_y = horizonTrussDistance * k
                    const tempSlopeTrussInfoObj = {
                        pos_x: pos_x,
                        pos_y: pos_y,
                        length: endSlopeTrussLength,
                        rotationZ : -endSlopeTrussAngle
                    }
                    endCrossBracingSlopeTruss.push(tempSlopeTrussInfoObj)
                }
            }

            const tempLegInfoObj ={
                pos_x: pos_x,
                length: length
            }
            
            
            endCrossBracingLegs.push(tempLegInfoObj)
        }

        return {
            dataInfoArray,
            endCrossBracingLegs,
            endCrossBracingHorizonTruss,
            endCrossBracingSlopeTruss
        };
    }, [params.p_h, params.p_w, params.p_r_p, params.p_r_s, roofRegularOffsetHeight, legDistance, trussType, params.singleSlope && params.freeStandingSide === "left", roofRailDistanceY, hiddenBaseRailIdArr, endBracingType, sideBracingType]);
    
    const sidePillarRailDataArr = useMemo(() => {
        let sideCrossBracingHorizonTruss = []
        let sideCrossBracingSlopeTruss = []
        let count, distance = 0;
        let horizonTrussCount = 0
        
        const initDistance = legDistance;
        const tempCount = Math.floor(params.p_d / initDistance);
        if (params.p_d === tempCount * initDistance) {
            count = tempCount;
            distance = initDistance;
        } else if (params.p_d - tempCount * initDistance < initDistance / 2) {
            count = tempCount;
            distance = params.p_d / count;
        } else {
            count = tempCount + 1;
            distance = params.p_d / count;
        }
        
        let divider = (sideBracingType == "v_bracings" || sideBracingType == "invert_v_bracings") ? 2 : 1
        const horizonTrussDistance = (distance / 2) / 4 * 5;
        const tempHorizonTrussCount = Math.floor(params.p_h / horizonTrussDistance)
        const slopeTrussAngle = Math.atan((distance/divider) / (horizonTrussDistance))
        const slopeTrussLength = Math.sqrt(Math.pow(horizonTrussDistance, 2) + Math.pow((distance/divider), 2)) - 0.14

        if (params.p_h > horizonTrussDistance * tempHorizonTrussCount) {
            horizonTrussCount = tempHorizonTrussCount + 1;
        } else {
            horizonTrussCount = tempHorizonTrussCount;
        }
    
        
        for(let i = 0; i < 2; i++) {
            let pos_Z, horizonCount;

            if(params.singleSlope && (horizonTrussDistance * (horizonTrussCount - 1) + railWidth) > (params.p_h - (railHeight) * params.p_r_p / 12)){
                horizonCount = horizonTrussCount - 1;
            } else {
                horizonCount = horizonTrussCount;
            }
            
            if(i === 0) {
                pos_Z = -params.p_d / 2

                for(let j = 1; j < horizonCount; j++) {
                    let pos_y;
                    pos_y = horizonTrussDistance * j
                    const tempHorizonTrussInfoObj = {
                        pos_Z: pos_Z,
                        pos_y: pos_y - railWidth / 2,
                        length: distance
                    }
                    sideCrossBracingHorizonTruss.push(tempHorizonTrussInfoObj)
                }
                for(let k = sideBracingHeightVal; k < horizonTrussCount - 1; k++) {
                    let pos_y;
                    pos_y = horizonTrussDistance * k
                    const tempSlopeTrussInfoObj = {
                        pos_Z: pos_Z + distance,
                        pos_y: pos_y - railWidth / 2,
                        length: slopeTrussLength,
                        rotationX : -(Math.PI / 2 + slopeTrussAngle)
                    }
                    sideCrossBracingSlopeTruss.push(tempSlopeTrussInfoObj)
                }
            } else if (i === 1) {
                let pos_y;
                pos_Z = params.p_d / 2 - distance
                
                for(let j = 1; j < horizonCount; j++) {
                    pos_y = horizonTrussDistance * j
                    const tempHorizonTrussInfoObj = {
                        pos_Z: pos_Z,
                        pos_y: pos_y - railWidth / 2,
                        length: distance
                    }
                    sideCrossBracingHorizonTruss.push(tempHorizonTrussInfoObj)
                    
                }
                for(let k = sideBracingHeightVal; k < horizonTrussCount - 1; k++) {
                    pos_y = horizonTrussDistance * k
                    const tempSlopeTrussInfoObj = {
                        pos_Z: pos_Z,
                        pos_y: pos_y - railWidth / 2,
                        length: slopeTrussLength,
                        rotationX : -(Math.PI / 2 - slopeTrussAngle)
                    }
                    sideCrossBracingSlopeTruss.push(tempSlopeTrussInfoObj)
                }
            }
        }

        return {
            sideCrossBracingHorizonTruss,
            sideCrossBracingSlopeTruss
        };
    }, [params.p_h, params.p_d, params.p_r_p, legDistance,trussType, params.singleSlope && params.freeStandingSide === "left", roofRailDistanceY, sideBracingType])
    
    /************** cutting hole using CSG ***************/
    const CSGFrontBackPillarRailModelArr = useMemo(() => {
        let frontModelArr = [];
        let backModelArr = [];
        let backStorageModelArr = [];
        let frontEndCrossBracingLegsArr = [];
        let frontEndCrossBracingHorizonTrussArr = [];
        let frontEndCrossBracingSlopeTrussArr = [];
        let backEndCrossBracingLegsArr = []
        let backEndCrossBracingHorizonTrussArr = [];
        let backEndCrossBracingSlopeTrussArr = []

        let baseCutModelForBraceFinal = baseCutModelForBraceMesh.clone()
        baseCutModelForBraceFinal.position.set(0,-baseThickness/2,-4/2)
        baseCutModelForBraceFinal.updateMatrixWorld();
        const baseCutModelForBrace = CSG.fromMesh(baseCutModelForBraceFinal);

        let roofCutMdelForBraceFinal = roofCutMdelForBraceMesh.clone()
        roofCutMdelForBraceFinal.position.set(0,0,-params.p_d/2)
        roofCutMdelForBraceFinal.updateMatrixWorld();
        const roofCutModelForBrace = CSG.fromMesh(roofCutMdelForBraceFinal);
        
        const modelShape = railModel(railWidth, railHeight);
        frontBackPillarRailDataArr.dataInfoArray.map((item) => {    
            const meshFrontPillarRailModel = new THREE.Mesh(
                new THREE.ExtrudeGeometry(modelShape, extrudeSettings(hiddenBaseRailIdArr.includes(trussModelPosInfoArr.length - 1) ? item.asyncLength :  item.length)),
                new THREE.MeshStandardMaterial({ color: 'pink' })
            )
            
            const meshBackPillarRailModel = new THREE.Mesh(
                new THREE.ExtrudeGeometry(modelShape, extrudeSettings(hiddenBaseRailIdArr.includes(0) ? item.asyncLength :  item.length)),
                new THREE.MeshStandardMaterial({ color: 'pink' })
            )
            
            const meshBackStoragePillarRailModel = new THREE.Mesh(
                new THREE.ExtrudeGeometry(modelShape, extrudeSettings((params.p_d % legDistance_temp === 0) ? (hiddenBaseRailIdArr.includes(params.p_u_t / legDistance_temp) ? item.asyncLength : item.length) : item.asyncLength)),
                new THREE.MeshStandardMaterial({ color: 'pink' })
            )
            let meshFrontPillarRailModel_Temp = meshFrontPillarRailModel.clone();    
            meshFrontPillarRailModel_Temp.position.set(item.pos_x, 0, 0);
            meshFrontPillarRailModel_Temp.rotateX(-Math.PI / 2);
            meshFrontPillarRailModel_Temp.updateMatrix();
            meshFrontPillarRailModel_Temp.updateMatrixWorld();
            const meshFrontPillarRailModel_CSG = CSG.fromMesh(meshFrontPillarRailModel_Temp);

            let meshBackPillarRailModel_Temp = meshBackPillarRailModel.clone();    
            meshBackPillarRailModel_Temp.position.set(item.pos_x, 0, 0);
            meshBackPillarRailModel_Temp.rotateX(-Math.PI / 2);
            meshBackPillarRailModel_Temp.updateMatrix();
            meshBackPillarRailModel_Temp.updateMatrixWorld();
            const meshBackPillarRailModel_CSG = CSG.fromMesh(meshBackPillarRailModel_Temp);

            let meshBackStoragePillarRailModel_Temp = meshBackStoragePillarRailModel.clone();    
            meshBackStoragePillarRailModel_Temp.position.set(item.pos_x, 0, 0);
            meshBackStoragePillarRailModel_Temp.rotateX(-Math.PI / 2);
            meshBackStoragePillarRailModel_Temp.updateMatrix();
            meshBackStoragePillarRailModel_Temp.updateMatrixWorld();
            const meshBackStoragePillarRailModel_CSG = CSG.fromMesh(meshBackStoragePillarRailModel_Temp);

            const frontPillarRailModel_CSG = meshFrontPillarRailModel_CSG.subtract(meshDelModel_CSG.front);
            const backPillarRailModel_CSG = meshBackPillarRailModel_CSG.subtract(meshDelModel_CSG.back);
            const backStoragePillarRailModel_CSG = meshBackStoragePillarRailModel_CSG.subtract(meshDelModel_CSG.backStorageFront);

            const CSGFrontPillarRailModel = CSG.toMesh(
                frontPillarRailModel_CSG,
                new THREE.Matrix4(),
                new THREE.MeshStandardMaterial({ color: 'blue' })
            )
            const CSGBackPillarRailModel = CSG.toMesh(
                backPillarRailModel_CSG,
                new THREE.Matrix4(),
                new THREE.MeshStandardMaterial({ color: 'blue' })
            )
            const CSGBackStoragePillarRailModel = CSG.toMesh(
                backStoragePillarRailModel_CSG,
                new THREE.Matrix4(),
                new THREE.MeshStandardMaterial({ color: 'blue' })
            )
        
            frontModelArr.push(CSGFrontPillarRailModel);
            backModelArr.push(CSGBackPillarRailModel);
            backStorageModelArr.push(CSGBackStoragePillarRailModel);

            return null;
        })

        frontBackPillarRailDataArr.endCrossBracingLegs.map((item) => {    

            let dynamicHeight = params.singleSlope ?  params.p_h - (params.p_w * (params.p_r_p/12)) + (((params.p_w/2) + item.pos_x) * (params.p_r_p/12) - 0.01) : item.length + roofRegularOffsetHeight - 0.1

            const meshPillarRailModel = new THREE.Mesh(
                new THREE.ExtrudeGeometry(modelShape, extrudeSettings(dynamicHeight)),
                new THREE.MeshStandardMaterial({ color: 'pink' })
            )
        
            let meshFrontEndCrossBracingLegs = meshPillarRailModel.clone();    
            meshFrontEndCrossBracingLegs.position.set(item.pos_x, 0, 0);
            meshFrontEndCrossBracingLegs.rotateX(-Math.PI / 2);
            meshFrontEndCrossBracingLegs.updateMatrix();
            meshFrontEndCrossBracingLegs.updateMatrixWorld();
            const meshFrontEndCrossBracingLegs_CSG = CSG.fromMesh(meshFrontEndCrossBracingLegs);
            const meshBackEndCrossBracingLegs_CSG = CSG.fromMesh(meshFrontEndCrossBracingLegs);

            const frontEndCrossBracingLegs_CSG = meshFrontEndCrossBracingLegs_CSG.subtract(meshDelModel_CSG.front);
            const backEndCrossBracingLegs_CSG = meshBackEndCrossBracingLegs_CSG.subtract(meshDelModel_CSG.back);
            
            const CSGFrontEndCrossBracingLegs = CSG.toMesh(
                frontEndCrossBracingLegs_CSG,
                new THREE.Matrix4(),
                new THREE.MeshStandardMaterial({ color: 'blue' })
            )
            const CSGBackEndCrossBracingLegs = CSG.toMesh(
                backEndCrossBracingLegs_CSG,
                new THREE.Matrix4(),
                new THREE.MeshStandardMaterial({ color: 'blue' })
            )
        
            frontEndCrossBracingLegsArr.push(CSGFrontEndCrossBracingLegs);
            backEndCrossBracingLegsArr.push(CSGBackEndCrossBracingLegs);
            

            return null;
        })

        frontBackPillarRailDataArr.endCrossBracingHorizonTruss.map((item) => {    
            const meshPillarRailModel = new THREE.Mesh(
                new THREE.ExtrudeGeometry(modelShape, extrudeSettings(item.length)),
                new THREE.MeshStandardMaterial({ color: 'pink' })
            )
        
            let meshFrontEndCrossBracingHorizonTruss = meshPillarRailModel.clone();    
            meshFrontEndCrossBracingHorizonTruss.position.set(item.pos_x, item.pos_y, 0);
            meshFrontEndCrossBracingHorizonTruss.rotateY(-Math.PI / 2);
            meshFrontEndCrossBracingHorizonTruss.rotateZ(Math.PI / 2);
            meshFrontEndCrossBracingHorizonTruss.updateMatrix();
            meshFrontEndCrossBracingHorizonTruss.updateMatrixWorld();
            const meshFrontEndCrossBracingHorizonTruss_CSG = CSG.fromMesh(meshFrontEndCrossBracingHorizonTruss);
            const meshBackEndCrossBracingHorizonTruss_CSG = CSG.fromMesh(meshFrontEndCrossBracingHorizonTruss);

            const frontEndCrossBracingHorizonTruss_CSG = meshFrontEndCrossBracingHorizonTruss_CSG.subtract(meshDelModel_CSG.front);
            const backEndCrossBracingHorizonTruss_CSG = meshBackEndCrossBracingHorizonTruss_CSG.subtract(meshDelModel_CSG.back);

            const CSGFrontEndCrossBracingHorizonTruss = CSG.toMesh(
                frontEndCrossBracingHorizonTruss_CSG,
                new THREE.Matrix4(),
                new THREE.MeshStandardMaterial({ color: 'blue' })
            )
            const CSGBackEndCrossBracingHorizonTruss = CSG.toMesh(
                backEndCrossBracingHorizonTruss_CSG,
                new THREE.Matrix4(),
                new THREE.MeshStandardMaterial({ color: 'blue' })
            )
        
            if((params.singleSlope && Math.sign(item.pos_x) === -1 && item.pos_y <= params.p_h - ((params.p_w) * (params.p_r_p/12))) || (!params.singleSlope) || (Math.sign(item.pos_x) === 1))frontEndCrossBracingHorizonTrussArr.push(CSGFrontEndCrossBracingHorizonTruss);
            if((params.singleSlope && Math.sign(item.pos_x) === -1 && item.pos_y <= params.p_h - ((params.p_w) * (params.p_r_p/12))) || (!params.singleSlope) || (Math.sign(item.pos_x) === 1))backEndCrossBracingHorizonTrussArr.push(CSGBackEndCrossBracingHorizonTruss);

            return null;
        })
        let distanceValue = 0
        frontBackPillarRailDataArr.endCrossBracingSlopeTruss.map((item,index,object) => {    
            let widthDistance = (endBracingType == "v_bracings") ? item.pos_x + (((params.p_w/2) - Math.abs(item.pos_x) - railWidth) * Math.sign(item.pos_x))/2 : item.pos_x;
            const meshPillarRailModel = new THREE.Mesh(
                new THREE.ExtrudeGeometry(modelShape, extrudeSettings(item.length)),
                new THREE.MeshStandardMaterial({ color: 'pink' })
            )
        
            let meshFrontEndCrossBracingSlopeTruss = meshPillarRailModel.clone();    
            meshFrontEndCrossBracingSlopeTruss.position.set(widthDistance, item.pos_y, 0);
            meshFrontEndCrossBracingSlopeTruss.rotateX(-Math.PI / 2);
            meshFrontEndCrossBracingSlopeTruss.rotateY(endBracingType == "v_bracings" ? item.rotationZ : -item.rotationZ);

            meshFrontEndCrossBracingSlopeTruss.updateMatrix();
            meshFrontEndCrossBracingSlopeTruss.updateMatrixWorld();
            const meshFrontEndCrossBracingSlopeTruss_CSG = CSG.fromMesh(meshFrontEndCrossBracingSlopeTruss);
            const meshBackEndCrossBracingSlopeTruss_CSG = CSG.fromMesh(meshFrontEndCrossBracingSlopeTruss);

            const frontEndCrossBracingSlopeTruss_CSGFinalRoof = meshFrontEndCrossBracingSlopeTruss_CSG.subtract(roofCutModelForBrace);
            const frontEndCrossBracingSlopeTruss_CSGFinalBase = frontEndCrossBracingSlopeTruss_CSGFinalRoof.subtract(baseCutModelForBrace);
            const frontEndCrossBracingSlopeTruss_CSG = frontEndCrossBracingSlopeTruss_CSGFinalBase.subtract(meshDelModel_CSG.front);
            const backEndCrossBracingSlopeTruss_CSGRoof = meshBackEndCrossBracingSlopeTruss_CSG.subtract(roofCutModelForBrace);
            const backEndCrossBracingSlopeTruss_CSGFinalBase = backEndCrossBracingSlopeTruss_CSGRoof.subtract(baseCutModelForBrace);
            const backEndCrossBracingSlopeTruss_CSG = backEndCrossBracingSlopeTruss_CSGFinalBase.subtract(meshDelModel_CSG.back);

            const CSGFrontEndCrossBracingSlopeTruss = CSG.toMesh(
                frontEndCrossBracingSlopeTruss_CSG,
                new THREE.Matrix4(),
                new THREE.MeshStandardMaterial({ color: 'blue' })
            )
            const CSGBackEndCrossBracingSlopeTruss = CSG.toMesh(
                backEndCrossBracingSlopeTruss_CSG,
                new THREE.Matrix4(),
                new THREE.MeshStandardMaterial({ color: 'blue' })
            )

            if(endBracingType == "x_bracings" || endBracingType == "invert_v_bracings" || endBracingType == "v_bracings" || endBracingType == "k_bay_bracings"){
                let meshFrontXEndCrossBracingSlopeTruss = meshPillarRailModel.clone();    
                if(endBracingType == "v_bracings"){
                    meshFrontXEndCrossBracingSlopeTruss.position.set(item.pos_x + (((params.p_w/2) - Math.abs(item.pos_x) - railWidth) * Math.sign(item.pos_x))/2, item.pos_y + railWidth/2, 0);
                    meshFrontXEndCrossBracingSlopeTruss.rotateX(-Math.PI / 2);
                    meshFrontXEndCrossBracingSlopeTruss.rotateY(-item.rotationZ);
                }else{
                    meshFrontXEndCrossBracingSlopeTruss.position.set(item.pos_x + (((params.p_w/2) - Math.abs(item.pos_x) - railWidth) * Math.sign(item.pos_x)), item.pos_y, 0);
                    meshFrontXEndCrossBracingSlopeTruss.rotateX(-Math.PI / 2);
                    meshFrontXEndCrossBracingSlopeTruss.rotateY(item.rotationZ);
                }

                meshFrontXEndCrossBracingSlopeTruss.updateMatrix();
                meshFrontXEndCrossBracingSlopeTruss.updateMatrixWorld();
                const meshFrontEndXCrossBracingSlopeTruss_CSG = CSG.fromMesh(meshFrontXEndCrossBracingSlopeTruss);
                const meshBackEndXCrossBracingSlopeTruss_CSG = CSG.fromMesh(meshFrontXEndCrossBracingSlopeTruss);

                const frontXEndCrossBracingSlopeTruss_CSGFinalRoof = meshFrontEndXCrossBracingSlopeTruss_CSG.subtract(roofCutModelForBrace);
                const frontXEndCrossBracingSlopeTruss_CSGFinal = frontXEndCrossBracingSlopeTruss_CSGFinalRoof.subtract(baseCutModelForBrace);
                const frontXEndCrossBracingSlopeTruss_CSG = frontXEndCrossBracingSlopeTruss_CSGFinal.subtract(meshDelModel_CSG.front);
                const backXEndCrossBracingSlopeTruss_CSGRoof = meshBackEndXCrossBracingSlopeTruss_CSG.subtract(roofCutModelForBrace);
                const backXEndCrossBracingSlopeTruss_CSGFinal = backXEndCrossBracingSlopeTruss_CSGRoof.subtract(baseCutModelForBrace);
                const backXEndCrossBracingSlopeTruss_CSG = backXEndCrossBracingSlopeTruss_CSGFinal.subtract(meshDelModel_CSG.back);

                const CSGFrontXEndCrossBracingSlopeTruss = CSG.toMesh(
                    frontXEndCrossBracingSlopeTruss_CSG,
                    new THREE.Matrix4(),
                    new THREE.MeshStandardMaterial({ color: 'blue' })
                )
                const CSGBackXEndCrossBracingSlopeTruss = CSG.toMesh(
                    backXEndCrossBracingSlopeTruss_CSG,
                    new THREE.Matrix4(),
                    new THREE.MeshStandardMaterial({ color: 'blue' })
                )
                
                if((params.singleSlope && Math.sign(item.pos_x) == -1 && (item.pos_y + distanceValue) < params.p_h - ((params.p_w) * (params.p_r_p/12))) || (!params.singleSlope) || (Math.sign(item.pos_x) == 1)){
                    frontEndCrossBracingSlopeTrussArr.push(CSGFrontXEndCrossBracingSlopeTruss);
                    backEndCrossBracingSlopeTrussArr.push(CSGBackXEndCrossBracingSlopeTruss);
                }
            }
        
            if(index === 1) distanceValue = item.pos_y - object[0].pos_y

            if((params.singleSlope && Math.sign(item.pos_x) === -1 && (item.pos_y + distanceValue) < params.p_h - ((params.p_w) * (params.p_r_p/12))) || (!params.singleSlope) || (Math.sign(item.pos_x) === 1))frontEndCrossBracingSlopeTrussArr.push(CSGFrontEndCrossBracingSlopeTruss);
            if((params.singleSlope && Math.sign(item.pos_x) === -1 && (item.pos_y + distanceValue) < params.p_h - ((params.p_w) * (params.p_r_p/12))) || (!params.singleSlope) || (Math.sign(item.pos_x) === 1))backEndCrossBracingSlopeTrussArr.push(CSGBackEndCrossBracingSlopeTruss);

            return null;
        })
        
        return { frontModelArr, frontEndCrossBracingLegsArr, frontEndCrossBracingHorizonTrussArr, frontEndCrossBracingSlopeTrussArr, backEndCrossBracingLegsArr, backEndCrossBracingHorizonTrussArr, backEndCrossBracingSlopeTrussArr, backModelArr, backStorageModelArr };
    }, [roofRegularOffsetHeight, roofCutMdelForBraceMesh, baseCutModelForBraceMesh, frontBackPillarRailDataArr, hiddenBaseRailIdArr, params.p_u_t, legDistance, legDistance_temp, params.p_d, meshDelModel_CSG.back, meshDelModel_CSG.front, meshDelModel_CSG.backStorageFront, params.p_r_s, params.p_w, params.p_h, endBracingType])

    const CSGFrontBackBottomRailData = useMemo(() => {
        const modelShape = railModel(railHeight, railWidth);

        const meshBottomRailModel = new THREE.Mesh(
            new THREE.ExtrudeGeometry(modelShape, extrudeSettings(params.p_w - 2 * railWidth)),
            new THREE.MeshStandardMaterial({ color: 'pink' })
        )
        
        let meshFrontBottomRailModel_Temp = meshBottomRailModel.clone();    
        meshFrontBottomRailModel_Temp.position.set(-params.p_w / 2 + railWidth, railWidth / 2, 0);
        meshFrontBottomRailModel_Temp.rotateY(Math.PI / 2);
        meshFrontBottomRailModel_Temp.updateMatrix();
        meshFrontBottomRailModel_Temp.updateMatrixWorld();
        const meshFrontBottomRailModel_CSG = CSG.fromMesh(meshFrontBottomRailModel_Temp);

        let meshBackBottomRailModel_Temp = meshBottomRailModel.clone();    
        meshBackBottomRailModel_Temp.position.set(-params.p_w / 2 + railWidth, railWidth / 2, 0);
        meshBackBottomRailModel_Temp.rotateY(Math.PI / 2);
        meshBackBottomRailModel_Temp.updateMatrix();
        meshBackBottomRailModel_Temp.updateMatrixWorld();
        const meshBackBottomRailModel_CSG = CSG.fromMesh(meshBackBottomRailModel_Temp);

        let meshBackStorageBottomRailModel_Temp = meshBottomRailModel.clone();    
        meshBackStorageBottomRailModel_Temp.position.set(-params.p_w / 2 + railWidth, railWidth / 2, 0);
        meshBackStorageBottomRailModel_Temp.rotateY(Math.PI / 2);
        meshBackStorageBottomRailModel_Temp.updateMatrix();
        meshBackStorageBottomRailModel_Temp.updateMatrixWorld();
        const meshBackStorageBottomRailModel_CSG = CSG.fromMesh(meshBackStorageBottomRailModel_Temp);

        const frontBottomRailModel_CSG = meshFrontBottomRailModel_CSG.subtract(meshDelModel_CSG.front);
        const backBottomRailModel_CSG = meshBackBottomRailModel_CSG.subtract(meshDelModel_CSG.back);
        const backStorageBottomRailModel_CSG = meshBackStorageBottomRailModel_CSG.subtract(meshDelModel_CSG.backStorageFront);

        const CSGFrontBottomRailModel = CSG.toMesh(
            frontBottomRailModel_CSG,
            new THREE.Matrix4(),
            new THREE.MeshStandardMaterial({ color: 'blue' })
        )
        CSGFrontBottomRailModel.rotateY(Math.PI / 2);
        CSGFrontBottomRailModel.position.set(-params.p_w / 2, railWidth / 2, 0)

        const CSGBackBottomRailModel = CSG.toMesh(
            backBottomRailModel_CSG,
            new THREE.Matrix4(),
            new THREE.MeshStandardMaterial({ color: 'blue' })
        )

        const CSGBackStorageBottomRailModel = CSG.toMesh(
            backStorageBottomRailModel_CSG,
            new THREE.Matrix4(),
            new THREE.MeshStandardMaterial({ color: 'blue' })
        )

        return { CSGFrontBottomRailModel, CSGBackBottomRailModel, CSGBackStorageBottomRailModel};
    }, [params.p_w, meshDelModel_CSG.back, meshDelModel_CSG.front, meshDelModel_CSG.backStorageFront])

    const CSGSideRailGroupModelArr = useMemo(() => {
        let leftModelArr = [];
        let leftStorageModelArr = [];
        // let leftConnectModelArr = [];
        let rightModelArr = [];
        let rightStorageModelArr = [];
        // let rightConnectModelArr = [];
        let leftSideCrossBracingHorizonTrussArr = [];
        let rightSideCrossBracingHorizonTrussArr = [];
        let leftSideCrossBracingSlopeTrussArr = [];
        let rightSideCrossBracingSlopeTrussArr = [];

        let leftStoragePillarLength = 0
        let rightStoragePillarLength = 0


        let baseCutModelForBraceFinal = baseCutModelForBraceMesh.clone()
        baseCutModelForBraceFinal.position.set(params.p_w/2,-baseThickness/2,params.p_d/-2)
        baseCutModelForBraceFinal.updateMatrixWorld();
        const baseCutModelForBrace = CSG.fromMesh(baseCutModelForBraceFinal);

        let roofCutMdelForBraceFinal = roofCutMdelForBraceMesh.clone()
        roofCutMdelForBraceFinal.position.set(params.p_w/2,0,params.p_d/-2)
        roofCutMdelForBraceFinal.updateMatrixWorld();
        const roofCutModelForBrace = CSG.fromMesh(roofCutMdelForBraceFinal);

        const dynamicHeight = params.singleSlope && params.freeStandingSide === "left" ? (params.p_h - ((params.p_r_p/12)*(params.p_w))) : params.p_r_s === 1 ? params.p_h : params.p_h - params.p_r_p / 12 * railHeight;
        const dynamicHeightRight = params.singleSlope && params.freeStandingSide === "right" ? (params.p_h + ((params.p_r_p/12)*(params.p_w))) - 0.1 : params.p_r_s === 1 ? params.p_h: params.p_h - params.p_r_p / 12 * railHeight;
        
        if(!params.singleSlope){
            if(params.cB_addStorage_left < params.p_w / 2) {
                leftStoragePillarLength = params.p_h + parseInt(params.cB_addStorage_left) * params.p_r_p / 12 + (params.p_r_s === 1 ? 0.8 : -0.2)
            } else{
                leftStoragePillarLength = params.p_h + (params.p_w - parseInt(params.cB_addStorage_left)) * params.p_r_p / 12 + (params.p_r_s === 1 ? 0.8 : -0.2)
            }
            if(params.cB_addStorage_right < params.p_w / 2) {
                rightStoragePillarLength = params.p_h + parseInt(params.cB_addStorage_right) * params.p_r_p / 12 + (params.p_r_s === 1 ? 0.8 : -0.2)
            } else{
                rightStoragePillarLength = params.p_h + (params.p_w - parseInt(params.cB_addStorage_right)) * params.p_r_p / 12 + (params.p_r_s === 1 ? 0.8 : -0.2)
            }
        } else {
            leftStoragePillarLength = params.p_h - params.p_w * params.p_r_p / 12 + parseInt(params.cB_addStorage_left) * params.p_r_p / 12 - 0.2
            rightStoragePillarLength = params.p_h - params.p_w * params.p_r_p / 12 + (params.p_w - parseInt(params.cB_addStorage_right)) * params.p_r_p / 12 - 0.2
        }
        
        const modelShape = railModel(railWidth, railHeight);
        const modelShapeConnect = railModel(railHeight, railWidth);

        const innerRightLegLength = (params.singleSlope ) ? dynamicHeight + (params.p_w - outInDistance) * params.p_r_p / 12 - 0.2 : dynamicHeightRight + outInDistance * params.p_r_p / 12 + (params.p_r_s === 1 && (const_var.legstype === "ladder" || const_var.legstype === "zigzag") && (const_var.roofRegularDst * 2 - 0.1));;
        const innerLeftLegLength = dynamicHeight + outInDistance * params.p_r_p / 12 + (params.p_r_s === 1 && (const_var.legstype === "ladder" || const_var.legstype === "zigzag") && (const_var.roofRegularDst * 2 - 0.1));;

        trussModelPosInfoArr.map((pos_z, index) => {    
            const meshOuterPillarRailModelL = new THREE.Mesh(
                new THREE.ExtrudeGeometry(modelShape, extrudeSettings(dynamicHeight )),
                new THREE.MeshStandardMaterial({ color: 'pink' })
            )

            const meshInnerPillarRailModelL = new THREE.Mesh(
                new THREE.ExtrudeGeometry(modelShape, extrudeSettings(innerLeftLegLength)),
                new THREE.MeshStandardMaterial({ color: 'pink' })
            )

            const meshOuterPillarRailModelR = new THREE.Mesh(
                new THREE.ExtrudeGeometry(modelShape, extrudeSettings((params.singleSlope ) ? params.p_h - 0.2 : dynamicHeightRight)),
                new THREE.MeshStandardMaterial({ color: 'pink' })
            )

            const meshInnerPillarRailModelR = new THREE.Mesh(
                new THREE.ExtrudeGeometry(modelShape, extrudeSettings(innerRightLegLength)),
                new THREE.MeshStandardMaterial({ color: 'pink' })
            )

            const meshLeftStoragePillarRailModel = new THREE.Mesh(
                new THREE.ExtrudeGeometry(modelShape, extrudeSettings( leftStoragePillarLength )),
                new THREE.MeshStandardMaterial({ color: 'pink' })
            )

            const meshRightStoragePillarRailModel = new THREE.Mesh(
                new THREE.ExtrudeGeometry(modelShape, extrudeSettings( rightStoragePillarLength )),
                new THREE.MeshStandardMaterial({ color: 'pink' })
            )

           //--- left -- outer
        
           let meshLeftOuterPillarRailModel_Temp = meshOuterPillarRailModelL.clone();    
           meshLeftOuterPillarRailModel_Temp.position.set(0.005, 0, pos_z);
           meshLeftOuterPillarRailModel_Temp.rotateX(-Math.PI / 2);
           meshLeftOuterPillarRailModel_Temp.updateMatrix();
           meshLeftOuterPillarRailModel_Temp.updateMatrixWorld();
           const meshLeftOuterPillarRailModel_CSG = CSG.fromMesh(meshLeftOuterPillarRailModel_Temp);

           const leftOuterPillarRailModel_CSG = meshLeftOuterPillarRailModel_CSG.subtract(meshDelModel_CSG.left);
           const CSGLeftOuterPillarRailModel = CSG.toMesh(
               leftOuterPillarRailModel_CSG,
               new THREE.Matrix4(),
               new THREE.MeshStandardMaterial({ color: 'blue' })
           )

           //--- left -- inner

           let meshLeftInnerPillarRailModel_Temp = meshInnerPillarRailModelL.clone();    
           meshLeftInnerPillarRailModel_Temp.position.set(0.005, 0, pos_z);
           meshLeftInnerPillarRailModel_Temp.rotateX(-Math.PI / 2);
           meshLeftInnerPillarRailModel_Temp.updateMatrix();
           meshLeftInnerPillarRailModel_Temp.updateMatrixWorld();
           const meshLeftInnerPillarRailModel_CSG = CSG.fromMesh(meshLeftInnerPillarRailModel_Temp);

           const leftInnerPillarRailModel_CSG = meshLeftInnerPillarRailModel_CSG.subtract(meshDelModel_CSG.left);
           const CSGLeftInnerPillarRailModel = CSG.toMesh(
               leftInnerPillarRailModel_CSG,
               new THREE.Matrix4(),
               new THREE.MeshStandardMaterial({ color: 'blue' })
           )

            //--- right -- outer

            let meshRightOuterPillarRailModel_Temp = meshOuterPillarRailModelR.clone();    
            meshRightOuterPillarRailModel_Temp.position.set(-0.005, 0, pos_z);
            meshRightOuterPillarRailModel_Temp.rotateX(-Math.PI / 2);
            meshRightOuterPillarRailModel_Temp.updateMatrix();
            meshRightOuterPillarRailModel_Temp.updateMatrixWorld();
            const meshRightOuterPillarRailModel_CSG = CSG.fromMesh(meshRightOuterPillarRailModel_Temp);

            const rightOuterPillarRailModel_CSG = meshRightOuterPillarRailModel_CSG.subtract(meshDelModel_CSG.right);
            const CSGRightOuterPillarRailModel = CSG.toMesh(
                rightOuterPillarRailModel_CSG,
                new THREE.Matrix4(),
                new THREE.MeshStandardMaterial({ color: 'blue' })
            )

            //--- right -- inner

            let meshRightInnerPillarRailModel_Temp = meshInnerPillarRailModelR.clone();    
            meshRightInnerPillarRailModel_Temp.position.set(-0.005, 0, pos_z);
            meshRightInnerPillarRailModel_Temp.rotateX(-Math.PI / 2);
            meshRightInnerPillarRailModel_Temp.updateMatrix();
            meshRightInnerPillarRailModel_Temp.updateMatrixWorld();
            const meshRightInnerPillarRailModel_CSG = CSG.fromMesh(meshRightInnerPillarRailModel_Temp);

            const rightInnerPillarRailModel_CSG = meshRightInnerPillarRailModel_CSG.subtract(meshDelModel_CSG.right);
            const CSGRightInnerPillarRailModel = CSG.toMesh(
                rightInnerPillarRailModel_CSG,
                new THREE.Matrix4(),
                new THREE.MeshStandardMaterial({ color: 'blue' })
            )

            //--- leftStorage -- 

            let meshLeftStoragePillarRailModel_Temp = meshLeftStoragePillarRailModel.clone();    
            meshLeftStoragePillarRailModel_Temp.position.set(0, 0, pos_z);
            meshLeftStoragePillarRailModel_Temp.rotateX(-Math.PI / 2);
            meshLeftStoragePillarRailModel_Temp.updateMatrix();
            meshLeftStoragePillarRailModel_Temp.updateMatrixWorld();
            const meshLeftStoragePillarRailModel_CSG = CSG.fromMesh(meshLeftStoragePillarRailModel_Temp);

            const leftStoragePillarRailModel_CSG = meshLeftStoragePillarRailModel_CSG.subtract(meshDelModel_CSG.leftStorageFront);
            const CSGLeftStoragePillarRailModel = CSG.toMesh(
                leftStoragePillarRailModel_CSG,
                new THREE.Matrix4(),
                new THREE.MeshStandardMaterial({ color: 'blue' })
            )

            //--- rightStorage -- 

            let meshRightStoragePillarRailModel_Temp = meshRightStoragePillarRailModel.clone();    
            meshRightStoragePillarRailModel_Temp.position.set(0, 0, pos_z);
            meshRightStoragePillarRailModel_Temp.rotateX(-Math.PI / 2);
            meshRightStoragePillarRailModel_Temp.updateMatrix();
            meshRightStoragePillarRailModel_Temp.updateMatrixWorld();
            const meshRightStoragePillarRailModel_CSG = CSG.fromMesh(meshRightStoragePillarRailModel_Temp);

            const rightStoragePillarRailModel_CSG = meshRightStoragePillarRailModel_CSG.subtract(meshDelModel_CSG.rightStorageFront);
            const CSGRightStoragePillarRailModel = CSG.toMesh(
                rightStoragePillarRailModel_CSG,
                new THREE.Matrix4(),
                new THREE.MeshStandardMaterial({ color: 'blue' })
            )
        
            leftModelArr.push({
                outer: CSGLeftOuterPillarRailModel,
                inner: CSGLeftInnerPillarRailModel
            });
            rightModelArr.push({
                outer: CSGRightOuterPillarRailModel,
                inner: CSGRightInnerPillarRailModel
            });

            if (index !== 0 && index !== trussModelPosInfoArr.length - 1) {
                leftStorageModelArr.push(CSGLeftStoragePillarRailModel);
                rightStorageModelArr.push(CSGRightStoragePillarRailModel);
            }

            return null;
        })

        sidePillarRailDataArr.sideCrossBracingHorizonTruss.map((item) => {    
            const meshPillarRailModel = new THREE.Mesh(
                new THREE.ExtrudeGeometry(modelShape, extrudeSettings(item.length)),
                new THREE.MeshStandardMaterial({ color: 'pink' })
            )
        
            let meshLeftSideCrossBracingHorizonTruss = meshPillarRailModel.clone();    
            meshLeftSideCrossBracingHorizonTruss.position.set(-0.05, item.pos_y, item.pos_Z);
            meshLeftSideCrossBracingHorizonTruss.rotateZ(Math.PI / 2);
            meshLeftSideCrossBracingHorizonTruss.updateMatrix();
            meshLeftSideCrossBracingHorizonTruss.updateMatrixWorld();
            const meshLeftSideCrossBracingHorizonTruss_CSG = CSG.fromMesh(meshLeftSideCrossBracingHorizonTruss);
            const meshRightSideCrossBracingHorizonTruss_CSG = CSG.fromMesh(meshLeftSideCrossBracingHorizonTruss);

            const leftSideCrossBracingHorizonTruss_CSG = meshLeftSideCrossBracingHorizonTruss_CSG.subtract(meshDelModel_CSG.left);
            const rightSideCrossBracingHorizonTruss_CSG = meshRightSideCrossBracingHorizonTruss_CSG.subtract(meshDelModel_CSG.right);

            const CSGLeftSideCrossBracingHorizonTruss = CSG.toMesh(
                leftSideCrossBracingHorizonTruss_CSG,
                new THREE.Matrix4(),
                new THREE.MeshStandardMaterial({ color: 'blue' })
            )
            const CSGRightSIdeCrossBracingHorizonTruss = CSG.toMesh(
                rightSideCrossBracingHorizonTruss_CSG,
                new THREE.Matrix4(),
                new THREE.MeshStandardMaterial({ color: 'blue' })
            )
        
            if((params.singleSlope && item.pos_y <= params.p_h - (params.p_w * (params.p_r_p/12))) || (!params.singleSlope))leftSideCrossBracingHorizonTrussArr.push(CSGLeftSideCrossBracingHorizonTruss);
            rightSideCrossBracingHorizonTrussArr.push(CSGRightSIdeCrossBracingHorizonTruss);

            return null;
        })

        let distanceValue = 0;
        sidePillarRailDataArr.sideCrossBracingSlopeTruss.map((item,index,object) => {    
            const sign = Math.sign(item.pos_Z)
            const railW = (sign == 1) ? railHeight : 0
            
            const meshPillarRailModel = new THREE.Mesh(
                new THREE.ExtrudeGeometry(modelShape, extrudeSettings(item.length)),
                new THREE.MeshStandardMaterial({ color: 'pink' })
            )
        
            let meshLeftSideCrossBracingSlopeTruss = meshPillarRailModel.clone();    
            meshLeftSideCrossBracingSlopeTruss.position.set(-0.05, item.pos_y, item.pos_Z + (sideBracingType == "v_bracings" && (((legDistance - railW) * sign) / 2))); 
            meshLeftSideCrossBracingSlopeTruss.rotateX(item.rotationX);
            meshLeftSideCrossBracingSlopeTruss.rotateZ(Math.PI / 2);
            meshLeftSideCrossBracingSlopeTruss.updateMatrix();
            meshLeftSideCrossBracingSlopeTruss.updateMatrixWorld();
            const meshLeftSideCrossBracingSlopeTruss_CSG = CSG.fromMesh(meshLeftSideCrossBracingSlopeTruss);
            const meshRightSideCrossBracingSlopeTruss_CSG = CSG.fromMesh(meshLeftSideCrossBracingSlopeTruss);

            const leftSideCrossBracingSlopeTruss_CSGFinalRoof = meshLeftSideCrossBracingSlopeTruss_CSG.subtract(roofCutModelForBrace);
            const leftSideCrossBracingSlopeTruss_CSGFinalBase = leftSideCrossBracingSlopeTruss_CSGFinalRoof.subtract(baseCutModelForBrace);
            const leftSideCrossBracingSlopeTruss_CSG = leftSideCrossBracingSlopeTruss_CSGFinalBase.subtract(meshDelModel_CSG.left);
            const rightSideCrossBracingSlopeTruss_CSGFinalroof = meshRightSideCrossBracingSlopeTruss_CSG.subtract(roofCutModelForBrace);
            const rightSideCrossBracingSlopeTruss_CSGFinalBase = rightSideCrossBracingSlopeTruss_CSGFinalroof.subtract(baseCutModelForBrace);
            const rightSideCrossBracingSlopeTruss_CSG = rightSideCrossBracingSlopeTruss_CSGFinalBase.subtract(meshDelModel_CSG.right);

            const CSGLeftSideCrossBracingSlopeTruss = CSG.toMesh(
                leftSideCrossBracingSlopeTruss_CSG,
                new THREE.Matrix4(),
                new THREE.MeshStandardMaterial({ color: 'blue' })
            )
            const CSGRightSIdeCrossBracingSlopeTruss = CSG.toMesh(
                rightSideCrossBracingSlopeTruss_CSG,
                new THREE.Matrix4(),
                new THREE.MeshStandardMaterial({ color: 'blue' })
            )

            if(sideBracingType == "x_bracings" || sideBracingType == "invert_v_bracings" || sideBracingType == "v_bracings" || sideBracingType == "k_bay_bracings"){
                let meshLeftXEndCrossBracingSlopeTruss = meshPillarRailModel.clone();    
                if(sideBracingType == "v_bracings"){
                    meshLeftXEndCrossBracingSlopeTruss.position.set(-0.05, item.pos_y, item.pos_Z + ((legDistance) * sign) / 2 );
                    meshLeftXEndCrossBracingSlopeTruss.rotateX(-item.rotationX - Math.PI);
                    meshLeftXEndCrossBracingSlopeTruss.rotateZ(-Math.PI / 2);
                }else{
                    meshLeftXEndCrossBracingSlopeTruss.position.set(-0.05, item.pos_y, item.pos_Z + ((legDistance) * sign));
                    meshLeftXEndCrossBracingSlopeTruss.rotateX(-item.rotationX - Math.PI);
                    meshLeftXEndCrossBracingSlopeTruss.rotateZ(Math.PI / 2);
                }
                meshLeftXEndCrossBracingSlopeTruss.updateMatrix();
                meshLeftXEndCrossBracingSlopeTruss.updateMatrixWorld();

                meshLeftXEndCrossBracingSlopeTruss.updateMatrix();
                meshLeftXEndCrossBracingSlopeTruss.updateMatrixWorld();
                const meshLeftEndXCrossBracingSlopeTruss_CSG = CSG.fromMesh(meshLeftXEndCrossBracingSlopeTruss);
                const meshRightEndXCrossBracingSlopeTruss_CSG = CSG.fromMesh(meshLeftXEndCrossBracingSlopeTruss);


                const leftXEndCrossBracingSlopeTruss_CSGRoof = meshLeftEndXCrossBracingSlopeTruss_CSG.subtract(roofCutModelForBrace);
                const leftXEndCrossBracingSlopeTruss_CSGFinalBase = leftXEndCrossBracingSlopeTruss_CSGRoof.subtract(baseCutModelForBrace);
                const leftXEndCrossBracingSlopeTruss_CSG = leftXEndCrossBracingSlopeTruss_CSGFinalBase.subtract(meshDelModel_CSG.left);
                const rightXEndCrossBracingSlopeTruss_CSGRoof = meshRightEndXCrossBracingSlopeTruss_CSG.subtract(roofCutModelForBrace);
                const rightXEndCrossBracingSlopeTruss_CSGFinalBase = rightXEndCrossBracingSlopeTruss_CSGRoof.subtract(baseCutModelForBrace);
                const rightXEndCrossBracingSlopeTruss_CSG = rightXEndCrossBracingSlopeTruss_CSGFinalBase.subtract(meshDelModel_CSG.right);

                const CSGLeftXEndCrossBracingSlopeTruss = CSG.toMesh(
                    leftXEndCrossBracingSlopeTruss_CSG,
                    new THREE.Matrix4(),
                    new THREE.MeshStandardMaterial({ color: 'blue' })
                )
                const CSGRightXEndCrossBracingSlopeTruss = CSG.toMesh(
                    rightXEndCrossBracingSlopeTruss_CSG,
                    new THREE.Matrix4(),
                    new THREE.MeshStandardMaterial({ color: 'blue' })
                )

                if(index == 1) distanceValue = item.pos_y - object[0].pos_y
                if((params.singleSlope && item.pos_y + distanceValue <= params.p_h - (params.p_w * (params.p_r_p/12))) || (!params.singleSlope)) {
                    leftSideCrossBracingSlopeTrussArr.push(CSGLeftXEndCrossBracingSlopeTruss);
                }
                rightSideCrossBracingSlopeTrussArr.push(CSGRightXEndCrossBracingSlopeTruss);
            }
        
            if(index === 1)distanceValue = item.pos_y - object[0].pos_y
            if((params.singleSlope && item.pos_y + distanceValue <= params.p_h - (params.p_w * (params.p_r_p/12))) || (!params.singleSlope)) leftSideCrossBracingSlopeTrussArr.push(CSGLeftSideCrossBracingSlopeTruss);
            rightSideCrossBracingSlopeTrussArr.push(CSGRightSIdeCrossBracingSlopeTruss);

            return null;
        })

        return {
            dynamicHeight,
            dynamicHeightRight,
            innerLeftLegLength,
            innerRightLegLength,
            leftStoragePillarLength,
            rightStoragePillarLength,
            
            leftModelArr,
            rightModelArr,
            leftStorageModelArr,
            rightStorageModelArr,
            leftSideCrossBracingHorizonTrussArr,
            rightSideCrossBracingHorizonTrussArr,
            leftSideCrossBracingSlopeTrussArr,
            rightSideCrossBracingSlopeTrussArr
        };
    }, [baseCutModelForBraceMesh, baseCutModelForBraceMesh, params.p_h, connectRailDataArr, meshDelModel_CSG.left, meshDelModel_CSG.right, trussModelPosInfoArr, meshDelModel_CSG.leftStorageFront, meshDelModel_CSG.rightStorageFront, params.singleSlope, params.freeStandingSide, params.p_r_p, params.p_w, params.p_r_s, outInDistance, const_var.legstype, sideBracingType, endBracingType])

    /****************************************** *********/

 
    //*************** instancing ********************/
    useMemo(() => {
        
            let isShowLeftLeg = true;
            let isShowRightLeg = true;
            let isShowLeftStorageLeg = true;
            let isShowRightStorageLeg = true;
            let tempLeftCSGLegIdArr = [];
            let tempRightCSGLegIdArr = [];
            let tempLeftStorageCSGLegIdArr = [];
            let tempRightStorageCSGLegIdArr = [];
            
            const leftSideCmpArry = [...const_var.newDoorsArray.filter((item) => wallNameArrForValid.find(subArray => subArray.includes('c_b_l_w')).includes(item.userData.wallName))];
            const rightSideCmpArry = [...const_var.newDoorsArray.filter((item) => wallNameArrForValid.find(subArray => subArray.includes('c_b_r_w')).includes(item.userData.wallName))];
            const leftStorageCmpArry = [...const_var.newDoorsArray.filter((item) => wallNameArrForValid.find(subArray => subArray.includes('c_b_l_s_r_w')).includes(item.userData.wallName))];
            const rightStorageCmpArry = [...const_var.newDoorsArray.filter((item) => wallNameArrForValid.find(subArray => subArray.includes('c_b_r_s_l_w')).includes(item.userData.wallName))];

            // let index_cnt_all = 0;
            const instanceMatRightInnerPillar = [];
            const instanceMatLeftInnerPillar = [];
            const instanceMatLeftConnectBottomRail = [];
            const instanceMatRightConnectBottomRail = [];
            const instanceMatLeftOuterPillar = [];
            const instanceMatRightOuterPillar = [];
            const instanceMatRightStoragePillar = [];
            const instanceMatLeftStoragePillar = [];
             trussModelPosInfoArr.forEach((pos_z, index_truss) => {
                //--- left outer leg
                obj_leftOuterPillar.position.set(-(params.p_w / 2 - railWidth / 2) + 0.055, 0, pos_z);
                obj_leftOuterPillar.rotation.x = -Math.PI / 2;
                obj_leftInnerPillar.position.set(-(params.p_w / 2 - railWidth / 2 - outInDistance), 0, pos_z);
                obj_leftInnerPillar.rotation.x = -Math.PI / 2;
                
                isShowLeftLeg = true
                leftSideCmpArry.every(element => {
                    let offsetForDoorDir = 1;
                    if (element.userData.wallName === 'L_L_R_S_W' || element.userData.wallName === 'G_L_L_B_W') offsetForDoorDir = -1;
                    if (pos_z + railHeight >= offsetForDoorDir * element.positionX - element.width / 2 && pos_z - railHeight <= offsetForDoorDir * element.positionX + element.width / 2) {
                        isShowLeftLeg = false;
                        tempLeftCSGLegIdArr.push(index_truss);
                        return false;
                    }
                    else return true;
                })
                if (!isShowLeftLeg || (!!overlapTrussArr && overlapTrussArr.buildingType === 'center' && overlapTrussArr.idArr.includes(index_truss))) {
                    obj_leftOuterPillar.scale.setScalar(0);
                } else {
                    obj_leftOuterPillar.scale.setScalar(1);
                }
                if (!isShowLeftLeg) {
                    obj_leftInnerPillar.scale.setScalar(0);
                } else {
                    obj_leftInnerPillar.scale.setScalar(1);
                }
                //----------

                //--- right outer leg
                obj_rightOuterPillar.position.set((params.p_w / 2 - railWidth / 2) - 0.055, 0, pos_z);
                obj_rightOuterPillar.rotation.x = -Math.PI / 2;
                obj_rightOuterPillar.scale.setScalar(1);

                obj_rightInnerPillar.position.set(params.p_w / 2 - railWidth / 2 - outInDistance, 0, pos_z);
                obj_rightInnerPillar.rotation.x = -Math.PI / 2;
                obj_rightInnerPillar.scale.setScalar(1);

                isShowRightLeg = true
                rightSideCmpArry.every(element => {
                    let offsetForDoorDir = 1;
                    if (element.userData.wallName === 'R_L_L_S_W' || element.userData.wallName === 'G_R_L_B_W') offsetForDoorDir = -1;
                    if (pos_z + railHeight >= offsetForDoorDir * (-element.positionX) - element.width / 2 && pos_z - railHeight <= offsetForDoorDir * (-element.positionX) + element.width / 2) {
                        isShowRightLeg = false;
                        tempRightCSGLegIdArr.push(index_truss);
                        return false;
                    }
                    else return true;
                })
                if (!isShowRightLeg || (!!overlapTrussArr && overlapTrussArr.buildingType === 'center' && overlapTrussArr.idArr.includes(index_truss))) {
                    obj_rightOuterPillar.scale.setScalar(0);
                }
                if (!isShowRightLeg) {
                    obj_rightInnerPillar.scale.setScalar(0);
                }
                //----------

                //--- left storage leg
                if (index_truss !== 0 && index_truss !== trussModelPosInfoArr.length - 1) {
                    obj_leftStoragePillar.position.set(-(params.p_w / 2 - parseInt(params.cB_addStorage_left) + railWidth / 2 + 0.05), 0, pos_z);
                    obj_leftStoragePillar.rotation.x = -Math.PI / 2;

                    isShowLeftStorageLeg = true
                    leftStorageCmpArry.every(element => {
                        if (pos_z + railHeight >= (-element.positionX) - element.width / 2 && pos_z - railHeight <= (-element.positionX) + element.width / 2) {
                            isShowLeftStorageLeg = false;
                            tempLeftStorageCSGLegIdArr.push(index_truss - 1);
                            return false;
                        }
                        else return true;
                    })
                    if (!isShowLeftStorageLeg || !params.cB_addStorage_check_left) {
                        obj_leftStoragePillar.scale.setScalar(0);
                    } else {
                        obj_leftStoragePillar.scale.setScalar(1);
                    }
                } else {
                    obj_leftStoragePillar.scale.setScalar(0);
                }
                //----------

                //--- right storage leg
                if (index_truss !== 0 && index_truss !== trussModelPosInfoArr.length - 1) {
                    obj_rightStoragePillar.position.set((params.p_w / 2 - parseInt(params.cB_addStorage_right) + railWidth / 2 + 0.05), 0, pos_z);
                    obj_rightStoragePillar.rotation.x = -Math.PI / 2;

                    isShowRightStorageLeg = true
                    rightStorageCmpArry.every(element => {
                        if (pos_z + railHeight >= (element.positionX) - element.width / 2 && pos_z - railHeight <= (element.positionX) + element.width / 2) {
                            isShowRightStorageLeg = false;
                            tempRightStorageCSGLegIdArr.push(index_truss - 1);
                            return false;
                        }
                        else return true;
                    })
                    if (!isShowRightStorageLeg || !params.cB_addStorage_check_right) {
                        obj_rightStoragePillar.scale.setScalar(0);
                    } else {
                        obj_rightStoragePillar.scale.setScalar(1);
                    }
                } else {
                    obj_rightStoragePillar.scale.setScalar(0);
                }
                //----------

                //--- connect leg
                obj_leftConnectBottomRail.position.set(-(params.p_w / 2 - railWidth / 2), railWidth / 2, pos_z)
                obj_leftConnectBottomRail.rotation.y = Math.PI / 2;
                obj_leftConnectBottomRail.scale.setScalar(1);

                obj_rightConnectBottomRail.position.set((params.p_w / 2 - railWidth / 2), railWidth / 2, pos_z)
                obj_rightConnectBottomRail.rotation.y = -Math.PI / 2;
                obj_rightConnectBottomRail.scale.setScalar(1);

                leftSideCmpArry.filter(filterElement => filterElement.userData.compType === "garage_door" || filterElement.userData.compType === "garage_door_frameout" || filterElement.userData.compType === "walkin" || filterElement.userData.compType === "walkin_frameout").forEach(element => {
                    if (pos_z + railHeight >= (element.positionX) - element.width / 2 && pos_z - railHeight <= (element.positionX) + element.width / 2) {
                        obj_leftConnectBottomRail.scale.setScalar(0);
                    }
                })
                rightSideCmpArry.filter(filterElement => filterElement.userData.compType === "garage_door" || filterElement.userData.compType === "garage_door_frameout" || filterElement.userData.compType === "walkin" || filterElement.userData.compType === "walkin_frameout").forEach(element => {
                    if (pos_z + railHeight >= (-element.positionX) - element.width / 2 && pos_z - railHeight <= (-element.positionX) + element.width / 2) {
                        obj_rightConnectBottomRail.scale.setScalar(0);
                    }
                })                

                obj_leftConnectBottomRail.updateMatrix();
                instanceMatLeftConnectBottomRail.push(...obj_leftConnectBottomRail.matrix.elements);
                obj_rightConnectBottomRail.updateMatrix();
                instanceMatRightConnectBottomRail.push(...obj_rightConnectBottomRail.matrix.elements);

                obj_leftOuterPillar.updateMatrix();
                instanceMatLeftOuterPillar.push(...obj_leftOuterPillar.matrix.elements)
                obj_leftInnerPillar.updateMatrix();
                instanceMatLeftInnerPillar.push(...obj_leftInnerPillar.matrix.elements);
                obj_rightOuterPillar.updateMatrix();
                instanceMatRightOuterPillar.push(...obj_rightOuterPillar.matrix.elements);
                obj_rightInnerPillar.updateMatrix();
                instanceMatRightInnerPillar.push(...obj_rightInnerPillar.matrix.elements);

                obj_leftStoragePillar.updateMatrix();
                obj_rightStoragePillar.updateMatrix();
                instanceMatRightStoragePillar.push(...obj_rightStoragePillar.matrix.elements);
                instanceMatLeftStoragePillar.push(...obj_leftStoragePillar.matrix.elements);
                
            })

            setCsgLeftLegIdArr(tempLeftCSGLegIdArr)
            setCsgRightLegIdArr(tempRightCSGLegIdArr)
            setCsgLeftStorageLegIdArr(tempLeftStorageCSGLegIdArr)
            setCsgRightStorageLegIdArr(tempRightStorageCSGLegIdArr)

            setLeftOuterPillar(new THREE.InstancedBufferAttribute(new Float32Array(instanceMatLeftOuterPillar), 16));            
            setLeftInnerPillar(new THREE.InstancedBufferAttribute(new Float32Array(instanceMatLeftInnerPillar), 16));            
            setRightOuterPillar(new THREE.InstancedBufferAttribute(new Float32Array(instanceMatRightOuterPillar), 16));
            setRightInnerPillar(new THREE.InstancedBufferAttribute(new Float32Array(instanceMatRightInnerPillar), 16));
            

            setLeftConnectBottomRail(new THREE.InstancedBufferAttribute(new Float32Array(instanceMatLeftConnectBottomRail), 16));  
            setRightConnectBottomRail(new THREE.InstancedBufferAttribute(new Float32Array(instanceMatRightConnectBottomRail), 16));            

            setLeftStoragePillar(new THREE.InstancedBufferAttribute(new Float32Array(instanceMatLeftStoragePillar), 16));
            setRightStoragePillar(new THREE.InstancedBufferAttribute(new Float32Array(instanceMatRightStoragePillar), 16));
        
        
        
    }, [params.p_e_l, const_var.legstype, params.p_w, params.p_r_p, params.p_h, params.singleSlope, params.freeStandingSide, const_var.newDoorsArray, outInDistance, trussModelPosInfoArr, overlapTrussArr, connectRailDataArr, params.cB_addStorage_check_left, params.cB_addStorage_check_right, params.cB_addStorage_left, params.cB_addStorage_right])


    const connectRails = useMemo(() => {

        let index_cnt_all = 0;
        const instanceMatLeftConnectRail = [];
        const instanceMatRightConnectRail = [];
        const leftSideCmpArry = [...const_var.newDoorsArray.filter((item) => wallNameArrForValid.find(subArray => subArray.includes('c_b_l_w')).includes(item.userData.wallName))];
        const rightSideCmpArry = [...const_var.newDoorsArray.filter((item) => wallNameArrForValid.find(subArray => subArray.includes('c_b_r_w')).includes(item.userData.wallName))];
       
        trussModelPosInfoArr.forEach((pos_z, index_truss) => {


            connectRailDataArr.dataInfoArray.forEach((item, index_cnt) => {
                if (index_cnt === 0)  return;

                obj_leftConnectRail.position.set(-item.pos_x_R, item.pos_y, pos_z);
                obj_leftConnectRail.rotation.y = Math.PI / 2;
                obj_leftConnectRail.rotateOnAxis(new THREE.Vector3(1, 0, 0), item.rotationX);
                obj_leftConnectRail.scale.setScalar(1);

                if (params.singleSlope && params.freeStandingSide === "left" && (item.pos_y >= params.p_h - ((params.p_r_p/12) * params.p_w))) {
                    obj_leftConnectRail.scale.setScalar(0);
                }

                obj_rightConnectRail.position.set(item.pos_x_R, item.pos_y, pos_z);
                obj_rightConnectRail.rotation.y = -Math.PI / 2;
                obj_rightConnectRail.rotateOnAxis(new THREE.Vector3(1, 0, 0), item.rotationX);
                obj_rightConnectRail.scale.setScalar(1);
                
                if (params.singleSlope && params.freeStandingSide === "right" && (item.pos_y >= params.p_h - ((params.p_r_p/12) * params.p_w))) {
                    obj_rightConnectRail.scale.setScalar(0);
                }

                leftSideCmpArry.forEach((element) => {
                    if (pos_z + railHeight >= (element.positionX) - element.width / 2 && pos_z - railHeight <= (element.positionX) + element.width / 2) {
                        const itemPosY = const_var.legstype === 'ladder' ? item.pos_y : item.pos_y - item.distance

                        if (element.userData.compType === "garage_door" || element.userData.compType === "garage_door_frameout" || element.userData.compType === "walkin" || element.userData.compType === "walkin_frameout") {
                            if (itemPosY - railWidth / 2 <= element.height) {
                                obj_leftConnectRail.scale.setScalar(0);
                            }
                        } else {
                            if (itemPosY - railWidth / 2 <= element.positionY + element.height / 2 && item.pos_y + railWidth / 2 >= element.positionY - element.height / 2) {
                                obj_leftConnectRail.scale.setScalar(0);
                            }
                        }
                    }
                })
                rightSideCmpArry.forEach((element) => {
                    if (pos_z + railHeight >= (-element.positionX) - element.width / 2 && pos_z - railHeight <= (-element.positionX) + element.width / 2) {
                        const itemPosY = const_var.legstype === 'ladder' ? item.pos_y : item.pos_y - item.distance

                        if (element.userData.compType === "garage_door" || element.userData.compType === "garage_door_frameout" || element.userData.compType === "walkin" || element.userData.compType === "walkin_frameout") {
                            if (itemPosY - railWidth / 2 <= element.height) {
                                obj_rightConnectRail.scale.setScalar(0);
                            }
                        } else {
                            if (itemPosY - railWidth / 2 <= element.positionY + element.height / 2 && item.pos_y + railWidth / 2 >= element.positionY - element.height / 2) {
                                obj_rightConnectRail.scale.setScalar(0);
                            }
                        }
                    }
                })
                
                obj_leftConnectRail.updateMatrix();
                instanceMatLeftConnectRail.push(...obj_leftConnectRail.matrix.elements);
                obj_rightConnectRail.updateMatrix();
                instanceMatRightConnectRail.push(...obj_rightConnectRail.matrix.elements);

                index_cnt_all ++;
            })
        })

            return { 
                leftConnectRail: new THREE.InstancedBufferAttribute(new Float32Array(instanceMatLeftConnectRail), 16),
                rightConnectRail: new THREE.InstancedBufferAttribute(new Float32Array(instanceMatRightConnectRail), 16)
            }

    }, [params.p_e_l, const_var.legstype, params.p_w, params.p_r_p, params.p_h, params.singleSlope, params.freeStandingSide, trussModelPosInfoArr, connectRailDataArr, const_var.newDoorsArray]);
    
    return (
        <group name='center_building_legs'>
            {params.p_f_w === 'Close' &&
                <>
                    {CSGFrontBackPillarRailModelArr.frontModelArr.map((item, index_front) =>
                        <mesh key={`front-vertical-rail-${index_front}`} name={`front_leg${index_front}`} geometry={item.geometry} position={[0, 0, params.p_d / 2 - 0.05]}>
                            <MaterialTruss normalMap={normalMap} envMap={envMap} />
                        </mesh>
                    )}
                    <mesh name='front_leg_base_rail' geometry={CSGFrontBackBottomRailData.CSGFrontBottomRailModel.geometry} position={[0, 0, params.p_d / 2 - 0.05]}>
                        <MaterialTruss normalMap={normalMap} envMap={envMap} />
                    </mesh>
                </>
            }
            {params.p_e_c_b && 
                <>
                    {CSGFrontBackPillarRailModelArr.frontEndCrossBracingLegsArr.map((item, index_front) =>
                        <mesh key={`front-leg-rail-${index_front}`} geometry={item.geometry} position={[0, 0, params.p_d / 2]}>
                            <MaterialTruss normalMap={normalMap} envMap={envMap} />
                        </mesh>
                    )}
                    {CSGFrontBackPillarRailModelArr.frontEndCrossBracingHorizonTrussArr.map((item, index_front_horizon) =>
                        <mesh key={`front-horizon-rail-${index_front_horizon}`} geometry={item.geometry} position={[0, 0, params.p_d / 2]}>
                            <MaterialTruss normalMap={normalMap} envMap={envMap} />
                        </mesh>
                    )}
                    {CSGFrontBackPillarRailModelArr.frontEndCrossBracingSlopeTrussArr.map((item, index_front_vertical) =>
                        <mesh key={`front-vertical-rail-${index_front_vertical}`} geometry={item.geometry} position={[0, 0, params.p_d / 2]}>
                            <MaterialTruss normalMap={normalMap} envMap={envMap} />
                        </mesh>
                    )}

                    {CSGFrontBackPillarRailModelArr.backEndCrossBracingLegsArr.map((item, index_back_leg) =>
                        <mesh key={`back-leg-rail-${index_back_leg}`} geometry={item.geometry} position={[0, 0, -params.p_d / 2]}>
                            <MaterialTruss normalMap={normalMap} envMap={envMap} />
                        </mesh>
                    )}
                    {CSGFrontBackPillarRailModelArr.backEndCrossBracingHorizonTrussArr.map((item, index_back_horizon) =>
                        <mesh key={`back-horizon-rail-${index_back_horizon}`} geometry={item.geometry} position={[0, 0, -params.p_d / 2]}>
                            <MaterialTruss normalMap={normalMap} envMap={envMap} />
                        </mesh>
                    )}
                    {CSGFrontBackPillarRailModelArr.backEndCrossBracingSlopeTrussArr.map((item, index_back_vertical) =>
                        <mesh key={`back-vertical-rail-${index_back_vertical}`} geometry={item.geometry} position={[0, 0, -params.p_d / 2]}>
                            <MaterialTruss normalMap={normalMap} envMap={envMap} />
                        </mesh>
                    )}
                </>
            }
            {params.p_s_c_b && 
                <>
                    {CSGSideRailGroupModelArr.leftSideCrossBracingHorizonTrussArr.map((item, index_side_horizon) =>
                        <mesh key={`side-horizon-rail-${index_side_horizon}`} geometry={item.geometry} position={[-params.p_w / 2 + railWidth / 2 + 0.155, 0, 0]}>
                            <MaterialTruss normalMap={normalMap} envMap={envMap} />
                        </mesh>
                    )}
                    {CSGSideRailGroupModelArr.leftSideCrossBracingSlopeTrussArr.map((item, index_side_vertical) =>
                        <mesh key={`side-vertical-rail-${index_side_vertical}`} geometry={item.geometry} position={[-params.p_w / 2 + railWidth / 2 + 0.155, 0, 0]}>
                            <MaterialTruss normalMap={normalMap} envMap={envMap} />
                        </mesh>
                    )}

                    {CSGSideRailGroupModelArr.rightSideCrossBracingHorizonTrussArr.map((item, index_side_horizon) =>
                        <mesh key={`side-horizon-rail-${index_side_horizon}`} geometry={item.geometry} position={[params.p_w / 2 - railWidth / 2 - 0.055, 0, 0]}>
                            <MaterialTruss normalMap={normalMap} envMap={envMap} />
                        </mesh>
                    )}
                    {CSGSideRailGroupModelArr.rightSideCrossBracingSlopeTrussArr.map((item, index_side_vertical) =>
                        <mesh key={`side-vertical-rail-${index_side_vertical}`} geometry={item.geometry} position={[params.p_w / 2 - railWidth / 2 - 0.055, 0, 0]}>
                            <MaterialTruss normalMap={normalMap} envMap={envMap} />
                        </mesh>
                    )}
                </>
            }
            {params.p_b_w === 'Close' &&
                <>
                    {CSGFrontBackPillarRailModelArr.backModelArr.map((item, index_front) =>
                        <mesh key={`back-vertical-rail-${index_front}`} name={`back_leg${index_front}`} geometry={item.geometry} position={[0, 0, -params.p_d / 2 + 0.05]}>
                            <MaterialTruss normalMap={normalMap} envMap={envMap} />
                        </mesh>
                    )}
                    <mesh name='back_leg_base_raill' geometry={CSGFrontBackBottomRailData.CSGBackBottomRailModel.geometry} position={[0, 0, -params.p_d / 2 + 0.05]}>
                        <MaterialTruss normalMap={normalMap} envMap={envMap} />
                    </mesh>
                </>
            }
           {params.cB_addStorage_check_left && 
                CSGSideRailGroupModelArr.leftStorageModelArr.map((item, index) =>
                    csgLeftStorageLegIdArr.includes(index) &&
                    <mesh key={`pillar-rail-${index}`} geometry={item.geometry} position={[-(params.p_w / 2 - parseInt(params.cB_addStorage_left) + railWidth / 2 + 0.05), 0, 0]}>
                        <MaterialTruss normalMap={normalMap} envMap={envMap} />
                    </mesh>
                )
            }
            {
                leftStoragePillar.array.length > 0 && [1].map((item) => <instancedMesh key={leftStoragePillar.array.length} instanceMatrix-needsUpdate={true} instanceMatrix={leftStoragePillar}/* ref={ref_leftStoragePillar} */ args={[null, null, trussModelPosInfoArr.length]} frustumCulled={false}>
                    <extrudeGeometry args={[railModel(railWidth, railHeight), extrudeSettings(CSGSideRailGroupModelArr.leftStoragePillarLength)]} />
                    <MaterialTruss normalMap={normalMap} envMap={envMap} />
                </instancedMesh>)
            }

            {params.cB_addStorage_check_right && 
                CSGSideRailGroupModelArr.rightStorageModelArr.map((item, index) =>
                    csgRightStorageLegIdArr.includes(index) && 
                    <mesh key={`pillar-rail-${index}`} geometry={item.geometry} position={[(params.p_w / 2 - parseInt(params.cB_addStorage_right) + railWidth / 2 + 0.05), 0, 0]}>
                        <MaterialTruss normalMap={normalMap} envMap={envMap} />
                    </mesh>
                )
            }
            {
                rightStoragePillar.array.length > 0 && [1].map((item) =>  <instancedMesh key={rightStoragePillar.array.length} /* ref={ref_rightStoragePillar} */ instanceMatrix-needsUpdate={true} instanceMatrix={rightStoragePillar} args={[null, null, trussModelPosInfoArr.length]} frustumCulled={false}>
                    <extrudeGeometry args={[railModel(railWidth, railHeight), extrudeSettings(CSGSideRailGroupModelArr.rightStoragePillarLength)]} />
                    <MaterialTruss normalMap={normalMap} envMap={envMap} />
                </instancedMesh>)
            }

            <VerticalLegs normalMap={normalMap} envMap={envMap} meshDelModel_CSG={meshDelModel_CSG} />
            <>
                {
                    params.p_e_l === true && (const_var.legstype === "ladder" || const_var.legstype === "zigzag") && leftConnectBottomRail.array.length > 0 && [1].map((item) => <instancedMesh key={leftConnectBottomRail.array.length} name='left_leg_bottom_connector' instanceMatrix-needsUpdate={true} instanceMatrix={leftConnectBottomRail} args={[null, null, trussModelPosInfoArr.length]} frustumCulled={false}>
                        <extrudeGeometry args={[railModel(railHeight, railWidth), extrudeSettings(outInDistance)]} />
                        <MaterialTruss normalMap={normalMap} envMap={envMap} />
                    </instancedMesh>)
                }
                {
                    params.p_e_l === true && (const_var.legstype === "ladder" || const_var.legstype === "zigzag") && connectRails?.leftConnectRail?.array.length > 0 && [1].map((item) => <instancedMesh key={connectRails.leftConnectRail.array.length} name='left_leg_connector' instanceMatrix-needsUpdate={true} instanceMatrix={connectRails.leftConnectRail} args={[null, null, trussModelPosInfoArr.length * (connectRailDataArr.dataInfoArray.length - 1)]} frustumCulled={false} >
                        <extrudeGeometry args={[railModel(railHeight, railWidth), const_var.legstype === 'ladder' ? extrudeSettings(connectRailDataArr.lengthLadder) : const_var.legstype === 'zigzag' ? extrudeSettings(connectRailDataArr.lengthZigzag) : 0]} />
                        <MaterialTruss normalMap={normalMap} envMap={envMap} />
                    </instancedMesh>)
                }
                {
                    params.p_e_l === true && (const_var.legstype === "ladder" || const_var.legstype === "zigzag") && rightConnectBottomRail.array.length > 0 && [1].map((item) => <instancedMesh key={rightConnectBottomRail.array.length} name='right_leg_bottom_connector' instanceMatrix-needsUpdate={true} instanceMatrix={rightConnectBottomRail} args={[null, null, trussModelPosInfoArr.length]} frustumCulled={false} >
                        <extrudeGeometry args={[railModel(railHeight, railWidth), extrudeSettings(outInDistance)]} />
                        <MaterialTruss normalMap={normalMap} envMap={envMap} />
                    </instancedMesh>)
                }
                {
                    params.p_e_l === true && (const_var.legstype === "ladder" || const_var.legstype === "zigzag") && connectRails?.rightConnectRail?.array.length > 0 && [1].map((item) => <instancedMesh key={connectRails.rightConnectRail.array.length} name='right_leg_connector' instanceMatrix-needsUpdate={true} instanceMatrix={connectRails.rightConnectRail} args={[null, null, trussModelPosInfoArr.length * (connectRailDataArr.dataInfoArray.length - 1)]} frustumCulled={false} >
                        <extrudeGeometry args={[railModel(railHeight, railWidth), const_var.legstype === 'ladder' ? extrudeSettings(connectRailDataArr.lengthLadder) : const_var.legstype === 'zigzag' ? extrudeSettings(connectRailDataArr.lengthZigzag) : 0]} />
                        <MaterialTruss normalMap={normalMap} envMap={envMap} />
                    </instancedMesh>)
                }

                
                {CSGSideRailGroupModelArr.leftModelArr.map((item, index) =>
                    csgLeftLegIdArr.includes(index) &&
                    <group key={`pillar-rail-legs-${index}`} name='pillar-rail-legs' renderOrder={2}>
                        <mesh name='left_leg' geometry={item.outer.geometry} position={[-(params.p_w / 2 - railWidth / 2) + 0.05, 0, 0]}>
                            <MaterialTruss normalMap={normalMap} envMap={envMap} />
                        </mesh>
                        {(params.p_e_l == true && (const_var.legstype =="double" || const_var.legstype == "ladder" || const_var.legstype == "zigzag")) ?
                            <mesh name='left_leg_inner' geometry={item.inner.geometry} position={[-(params.p_w / 2 - railWidth / 2 - outInDistance), 0, 0]}>
                                <meshPhongMaterial color={"#F0F0F0"} map={normalMap} envMap={envMap} side={THREE.DoubleSide} reflectivity={0.4} />
                            </mesh>
                            :
                            null
                        }
                    </group>
                )}

                {/* --- left outer pillar model normal --- */}
                {leftOuterPillar.array.length > 0 && [1].map(() =>
                    <instancedMesh key={leftOuterPillar.array.length}  name='left_leg' instanceMatrix-needsUpdate={true} instanceMatrix={leftOuterPillar}/* ref={ref_leftOuterPillar} */ args={[null, null, trussModelPosInfoArr.length]} frustumCulled={false}>
                        <extrudeGeometry args={[railModel(railWidth, railHeight), extrudeSettings(CSGSideRailGroupModelArr.dynamicHeight)]} />
                        <MaterialTruss normalMap={normalMap} envMap={envMap} />
                    </instancedMesh>
                )}

                {/* --- left inner pillar model normal --- */}
                {params.p_e_l == true && (const_var.legstype =="double" || const_var.legstype == "ladder" || const_var.legstype == "zigzag") && leftInnerPillar.array.length > 0 && [1].map((item) =>
                    <instancedMesh key={leftInnerPillar.array.length} name='left_leg_inner' instanceMatrix-needsUpdate={true} instanceMatrix={leftInnerPillar} args={[null, null, trussModelPosInfoArr.length]} frustumCulled={false}>
                        <extrudeGeometry args={[railModel(railWidth, railHeight), extrudeSettings(CSGSideRailGroupModelArr.innerLeftLegLength)]} />
                        <MaterialTruss normalMap={normalMap} envMap={envMap} />
                    </instancedMesh>
                )}

                {CSGSideRailGroupModelArr.rightModelArr.map((item, index) =>
                    csgRightLegIdArr.includes(index) &&
                    <group key={`pillar-rail-${index}`} name='pillar-rail-legs'>
                        <mesh name='right_leg' geometry={item.outer.geometry} position={[(params.p_w / 2 - railWidth / 2 - 0.05), 0, 0]}>
                            <MaterialTruss normalMap={normalMap} envMap={envMap} />
                        </mesh>
                        {(params.p_e_l == true && (const_var.legstype =="double" || const_var.legstype == "ladder" || const_var.legstype == "zigzag")) ?
                            <mesh name='right_leg_inner' geometry={item.inner.geometry} position={[(params.p_w / 2 - railWidth / 2 - outInDistance), 0, 0]}>
                                <MaterialTruss normalMap={normalMap} envMap={envMap} />
                            </mesh>
                            :
                            null
                        }
                    </group>
                )}

                {/* --- right outer pillar model normal --- */}
                {rightOuterPillar.array.length > 0 && [1].map((item) =>
                    <instancedMesh key={rightOuterPillar.array.length} name='right_leg' instanceMatrix-needsUpdate={true} instanceMatrix={rightOuterPillar} /* ref={ref_rightOuterPillar} */ args={[null, null, trussModelPosInfoArr.length]} frustumCulled={false}>
                        <extrudeGeometry args={[railModel(railWidth, railHeight), extrudeSettings(CSGSideRailGroupModelArr.dynamicHeightRight)]} />
                        <MaterialTruss normalMap={normalMap} envMap={envMap} />
                    </instancedMesh>
                )}
                
                {/* --- right inner pillar model normal --- */}
                {params.p_e_l == true && (const_var.legstype =="double" || const_var.legstype == "ladder" || const_var.legstype == "zigzag") && rightInnerPillar.array.length > 0 && [1].map((item) =>
                    <instancedMesh key={rightInnerPillar.array.length} name='right_leg_inner' instanceMatrix-needsUpdate={true} instanceMatrix={rightInnerPillar} args={[null, null, trussModelPosInfoArr.length]} frustumCulled={false}>
                        <extrudeGeometry args={[railModel(railWidth, railHeight), extrudeSettings(CSGSideRailGroupModelArr.innerRightLegLength)]} />
                        <MaterialTruss normalMap={normalMap} envMap={envMap} />
                    </instancedMesh>
                )}
            </>
        </group>
    )
}

export default PillarRailModel